export function runOnNextTick(fn) {
  if (typeof fn !== 'function') return;

  if (typeof queueMicrotask === 'function') {
    queueMicrotask(fn);
    return;
  }

  setTimeout(fn, 0);
}

export function isModifiedPasteShortcutEvent(event) {
  if (!event) return false;

  const key = String(event.key || '').toLowerCase();
  const hasPrimaryModifier = Boolean(event.ctrlKey || event.metaKey);

  // Ctrl/Cmd+Shift+V and Shift+Insert are the canonical paste-without-format shortcuts.
  if (hasPrimaryModifier && event.shiftKey && key === 'v') return true;
  if (event.shiftKey && key === 'insert') return true;

  return false;
}
